import styles from './InputField.module.scss'
import { useFormContext } from 'react-hook-form'
import ButtonWithInput from '../../../pages/signup/components/Button/ButtonWithInput'

export const InputField = ({
	name,
	label,
	optional = false,
	placeholder,
	validation,
	type,
	buttonLabel,
	buttonAction,
	children,
	useChildrenWrapper = true,
}) => {
	const {
		register,
		setValue,
		formState: { errors },
	} = useFormContext()
	const registration = register(name, validation)
	return (
		<div className={styles.infoBox}>
			<span>
				{label}
				{optional && <span className={styles.choice}> (선택) </span>}
			</span>
			<div>
				<div className={`${styles.fillinBox} ${errors?.[name] ? styles.error : ''}`}>
					<input
						className={styles.fillinInput}
						type={type || name}
						placeholder={placeholder}
						{...register(name, validation)}
						onBlur={(e) => {
							registration.onBlur(e)
						}}
					/>
				</div>
			</div>
			<div>
				{errors?.[name] && (
					<div>
						<small className={styles.validationMsg} style={{ color: 'red' }}>
							{errors[name].message}
						</small>
					</div>
				)}
			</div>
		</div>
	)
}
